"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonDropdown = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var Menu_1 = tslib_1.__importDefault(require("@material-ui/core/Menu"));
var isEmpty_1 = tslib_1.__importDefault(require("lodash/fp/isEmpty"));
var noop_1 = tslib_1.__importDefault(require("lodash/fp/noop"));
var IconButton_1 = require("../IconButton");
var Button_1 = require("../Button");
var ButtonDropdownLabel_1 = tslib_1.__importDefault(require("./ButtonDropdownLabel"));
var ButtonDropdownFooter_1 = tslib_1.__importDefault(require("./ButtonDropdownFooter"));
exports.ButtonDropdown = function (props) {
    var _a = props.buttonIcon, buttonIcon = _a === void 0 ? '' : _a, _b = props.borderless, borderless = _b === void 0 ? false : _b, _c = props.children, children = _c === void 0 ? '' : _c, _d = props.disabled, disabled = _d === void 0 ? false : _d, _e = props.buttonLabel, buttonLabel = _e === void 0 ? '' : _e, _f = props.hideButtonLabel, hideButtonLabel = _f === void 0 ? false : _f, _g = props.selectedValue, selectedValue = _g === void 0 ? '' : _g, _h = props.showSelectedValue, showSelectedValue = _h === void 0 ? false : _h, _j = props.showDropdownIcon, showDropdownIcon = _j === void 0 ? false : _j, _k = props.showFooter, showFooter = _k === void 0 ? false : _k, _l = props.onApply, onApply = _l === void 0 ? noop_1.default : _l, _m = props.onCancel, onCancel = _m === void 0 ? noop_1.default : _m, _o = props.iconButton, iconButton = _o === void 0 ? false : _o, _p = props.secondary, secondary = _p === void 0 ? false : _p, _q = props.menu, menu = _q === void 0 ? {} : _q, _r = props.disableOnApply, disableOnApply = _r === void 0 ? false : _r;
    var _s = react_1.useState({}), anchorEl = _s[0], setAnchorEl = _s[1];
    var handleClose = react_1.useCallback(function () {
        setAnchorEl({});
    }, [setAnchorEl]);
    var handleClick = react_1.useCallback(function (event) {
        setAnchorEl(event.currentTarget);
    }, [setAnchorEl]);
    var handleApply = function () {
        handleClose();
        onApply();
    };
    var handleCancel = function () {
        handleClose();
        onCancel();
    };
    var button = iconButton ? (react_1.default.createElement(IconButton_1.IconButton, { icon: buttonIcon, onClick: handleClick, disabled: disabled })) : (react_1.default.createElement(Button_1.Button, { buttonStyle: "SECONDARY", includeDropdownButton: showDropdownIcon, icon: buttonIcon, onClick: handleClick, borderless: borderless, disabled: disabled },
        react_1.default.createElement(ButtonDropdownLabel_1.default, { selectedValue: selectedValue, buttonLabel: buttonLabel, hideButtonLabel: hideButtonLabel, showSelectedValue: showSelectedValue })));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        button,
        react_1.default.createElement(StyledMenu, tslib_1.__assign({ anchorEl: anchorEl, keepMounted: true, open: !isEmpty_1.default(anchorEl), onClose: handleCancel, transformOrigin: { vertical: 'top', horizontal: 'left' } }, menu),
            react_1.default.Children.map(children, function (child) {
                return react_1.cloneElement(child, { handleCancel: handleCancel });
            }),
            showFooter && (react_1.default.createElement(ButtonDropdownFooter_1.default, { secondary: secondary, onApply: handleApply, onCancel: handleCancel, disableOnApply: disableOnApply })))));
};
exports.ButtonDropdown.defaultProps = {
    borderless: false,
    buttonIcon: '',
    disabled: false,
    buttonLabel: '',
    showSelectedValue: false,
    showDropdownIcon: false,
    selectedValue: '',
};
var StyledMenu = styled_components_1.default(function (props) { return (react_1.default.createElement(Menu_1.default, tslib_1.__assign({}, props, { classes: { paper: 'paper' } }))); })(function () { return ({
    '&&': {
        padding: '0.8rem 0rem',
        fontSize: '1.3rem',
        '.paper': {
            borderRadius: '0px',
            marginTop: '3.2rem',
        },
    },
}); }, function (_a) {
    var style = _a.style;
    return style || {};
});
